import { render, staticRenderFns } from "./OptionPreview.vue?vue&type=template&id=f4767dc6&scoped=true"
import script from "./OptionPreview.vue?vue&type=script&lang=js"
export * from "./OptionPreview.vue?vue&type=script&lang=js"
import style0 from "./OptionPreview.vue?vue&type=style&index=0&id=f4767dc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4767dc6",
  null
  
)

export default component.exports